<template>
<div class='columns is-centered my-col'>
  <div class='column bg-div' :class="myClass">
    <slot></slot>
  </div>
</div>
</template>


<script>
export default {
  props: {
    myClass: String
  }
}
</script>
